import CompanyHeadquarterFilter from "../../components/filters/CompanyHeadquarterFilter/CompanyHeadquarterFilter";
import CompanyHeadquarterFilterResult from "../../components/filters/CompanyHeadquarterFilter/CompanyHeadquarterFilterResult";
import { leadsFilterApiCategory } from "../../types/leadsFilterApiCategory";
import { leadsFilterCategoryMap } from "../../types/leadsFilterCategory";
import { defineDescriptionFilter } from "../defineSourcedFilter";

import FindCompanyHeadquarterFilter from "./CompanyHeadquarterFilter";

export const companyHeadquarterDefinition = defineDescriptionFilter({
    key: "companyHeadquarter",
    apiCategory: leadsFilterApiCategory.companyHeadquarter,
    category: leadsFilterCategoryMap.company,
    trackingName: "hq location",
    titleKey: { key: "si.lead_gen_filters.group.company_headquarter.name" },

    render: ({ description, countryService }) => ({
        tooltipText: { key: "si.lead_gen_filters.group.companyHeadquarter.tooltip" },
        filter: new FindCompanyHeadquarterFilter({
            options: {
                inclusions: description.companyHeadquarter.inclusions,
                countries: countryService.allCountries,
                states: countryService.usStateOptions,
                regions: countryService.allRegions,
            },
        }),
        filterView: CompanyHeadquarterFilter,
        filterResultView: CompanyHeadquarterFilterResult,
    }),
});
